import * as React from 'react';
import styled from '../styled-components';
import { mapMedia } from '../media';

function verticalPropValue(vertical) {
  if (vertical === 'top') {
    return 'flex-start';
  }

  if (vertical === 'bottom') {
    return 'flex-end';
  }

  return vertical;
}

function horizontalPropValue(horizontal) {
  if (horizontal === 'left') {
    return 'flex-start';
  }

  if (horizontal === 'right') {
    return 'flex-end';
  }

  return horizontal;
}

var PlacementImpl =
/*#__PURE__*/
styled.div.withConfig({
  displayName: "Placement__PlacementImpl",
  componentId: "sc-9571m5-0"
})(["display:flex;height:100%;width:100%;", ";"], mapMedia(function (prop) {
  var vertical = prop('vertical');
  var horizontal = prop('horizontal');
  return [vertical && {
    alignItems: verticalPropValue(vertical)
  }, horizontal && {
    justifyContent: horizontalPropValue(horizontal)
  }];
}));

var Placement = function Placement(props) {
  return React.createElement(PlacementImpl, props);
};

Placement.defaultProps = {
  horizontal: 'left',
  vertical: 'top'
};
export default Placement;